function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7018 0H6.04035C5.2614 0 4.6276 0.633799 4.6276 1.41275V3.10845H3.298C2.51905 3.10845 1.88525 3.74217 1.88525 4.5212V18.5873C1.88525 19.3662 2.51905 20 3.298 20H13.9594C14.7384 20 15.3722 19.3662 15.3722 18.5873V16.8916H16.7018C17.4808 16.8916 18.1146 16.2578 18.1146 15.4789V1.41275C18.1146 0.633799 17.4809 0 16.7018 0ZM14.1612 18.5873C14.1612 18.6966 14.0688 18.7891 13.9594 18.7891H3.298C3.18862 18.7891 3.09618 18.6966 3.09618 18.5873V4.5212C3.09618 4.41173 3.18862 4.31938 3.298 4.31938H13.9594C14.0688 4.31938 14.1612 4.41173 14.1612 4.5212V18.5873V18.5873ZM16.9037 15.4789C16.9037 15.5883 16.8112 15.6807 16.7018 15.6807H15.3722V4.5212C15.3722 3.74217 14.7384 3.10845 13.9594 3.10845H5.83853V1.41275C5.83853 1.30336 5.93088 1.21093 6.04035 1.21093H16.7018C16.8112 1.21093 16.9037 1.30336 16.9037 1.41275V15.4789Z",
  fill: "#667681"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0729 6.22583H5.18408C4.84962 6.22583 4.57861 6.49684 4.57861 6.83129C4.57861 7.16575 4.84962 7.43676 5.18408 7.43676H12.0729C12.4073 7.43676 12.6783 7.16575 12.6783 6.83129C12.6783 6.49692 12.4073 6.22583 12.0729 6.22583Z",
  fill: "#667681"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0729 8.95264H5.18408C4.84962 8.95264 4.57861 9.22364 4.57861 9.5581C4.57861 9.89256 4.84962 10.1636 5.18408 10.1636H12.0729C12.4073 10.1636 12.6783 9.89256 12.6783 9.5581C12.6783 9.22364 12.4073 8.95264 12.0729 8.95264Z",
  fill: "#667681"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0729 11.6794H5.18408C4.84962 11.6794 4.57861 11.9504 4.57861 12.2849C4.57861 12.6194 4.84962 12.8904 5.18408 12.8904H12.0729C12.4073 12.8904 12.6783 12.6194 12.6783 12.2849C12.6783 11.9504 12.4073 11.6794 12.0729 11.6794Z",
  fill: "#667681"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0729 14.4061H5.18408C4.84962 14.4061 4.57861 14.6771 4.57861 15.0116C4.57861 15.346 4.84962 15.6171 5.18408 15.6171H12.0729C12.4073 15.6171 12.6783 15.346 12.6783 15.0116C12.6783 14.6772 12.4073 14.4061 12.0729 14.4061Z",
  fill: "#667681"
});

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.9f6e8f4f.svg";
export { ForwardRef as ReactComponent };